/* @flow */
import * as React from 'react';
import cx from 'classnames';
import MediaObject from 'components/MediaObject';
import Glyph from 'components/Glyph';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import Link from 'components/Link';

import './Banner.scss';

type Props = {
  children?: ?any,
  className?: ?string,
  type: 'normal' | 'warning',
  onClose?: () => void,
};

class Banner extends React.Component<Props> {
  static propClasses = {
    type: {
      warning: 'Banner-typeWarning',
    },
  };

  render() {
    return (
      <MediaObject
        {...this.props}
        figure="right"
        gutter="xsmall"
        className={cx('Banner', getPropClassesFromInstance(this), this.props.className)}>
        <div className="Banner-content">{this.props.children}</div>
        {this.props.onClose ? (
          <Link
            className="Banner-closeButton"
            color="white"
            onClick={this.props.onClose}
            eventElementName="Banner-closeButton">
            <Glyph name="close" size="medium" solo />
          </Link>
        ) : (
          <span />
        )}
      </MediaObject>
    );
  }
}

export default Banner;
